import React from "react";

import styled from "styled-components";
const Wrapper = styled.div`
  background-color: #000;

  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px 25px;

  .icon {
    width: 40px;
    margin: 0 12px;
  }
  @media only screen and (max-width: 991px) {
    .icon {
      width: 30px;
      margin: 0 9px;
    }
  }
`;
const Footer = () => {
  const socialArray = [
    { icon: "./images/twitter.png", to: "https://twitter.com/moonbirdsazuki" },
    { icon: "./images/opensea.png", to: "https://opensea.io/" },
    { icon: "./images/discord.png", to: "https://discord.com/" },
  ];
  return (
    <Wrapper>
      {socialArray.map((el, i) => (
        <a href={el.to} key={i} target="_blank" rel="noreferrer">
          <img src={el.icon} alt="#" className="icon" />
        </a>
      ))}
    </Wrapper>
  );
};
export default Footer;
